import { createRoot } from 'react-dom/client';
import App from './app/app';
import './index.scss';
import 'react-datepicker/dist/react-datepicker.css';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
import calendar from 'dayjs/plugin/calendar';
import timezone from 'dayjs/plugin/timezone';
import updateLocale from 'dayjs/plugin/updateLocale';
import { appInsights } from './core/telemetry/app-insights';

dayjs.extend(customParseFormat);
dayjs.extend(duration);
dayjs.extend(calendar);
dayjs.extend(updateLocale);
dayjs.extend(timezone);

dayjs.updateLocale('en', {
  calendar: {
    lastDay: '[Yesterday] h:mm A',
    sameDay: '[Today] h:mm A',
    nextDay: '[Tomorrow] h:mm A',
    lastWeek: 'DD/MM/YYYY',
    nextWeek: 'DD/MM/YYYY',
    sameElse: 'DD/MM/YYYY'
  }
});

const debounce = (fn: Function, delay: number) => {
  let timer: NodeJS.Timeout;
  return function () {
    const args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(null, args);
    }, delay);
  };
};

const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback: ResizeObserverCallback) {
    callback = debounce(callback, 16);
    super(callback);
  }
};

appInsights.loadAppInsights();

createRoot(document.getElementById('root')!).render(<App />);
